'use client';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "prefixCls", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from 'react';
import FlexBasic from "../FlexBasic";
import { getPrefix } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Flexbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    prefixCls = _ref.prefixCls,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(FlexBasic, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    internalClassName: "".concat(getPrefix(prefixCls), "-flexbox"),
    className: className,
    children: children
  }));
});
Flexbox.displayName = 'Flexbox';
export { Flexbox };